module.exports = __webpack_public_path__ + "static/media/dog.8bcc394e.svg";